<div class="cb-header__wrap cb-transition__slide" id="cb-header-wrap" ref="parent">
  <div class="cb-header__animate">
    <cb-slide-n-fade>
      <div class="cb-header__logo cb-transition__slide" v-if="this.$route.meta.headerLogo && logo">
        <img class="cb-header__image" :src="logo" alt="logo" :class="{'cb-header__image--xl':scaleLogo}">
      </div>
    </cb-slide-n-fade>
    <cb-slide-n-fade>
      <div class="cb-header__content" key="thankyou" :class="{'cb-header__content--fade': fadeHeaderContent}" v-if="!showReferralSection">
        <div class="cb-header__heading" v-if="headerText">
          {{ headerText }}
        </div>
        <div class="cb-header__desc" v-if="bodyText">
          {{ bodyText }}
        </div>
        <div class="cb-header__close" v-if="thankYouClose">
          <button-field @next="close()" :custom-class="'secondary'" aria-label="close checkout" :attr="'cb_close'">
            {{ thankYouClose }}
          </button-field>
        </div>
        <div class="cb-section cb-section--nomargin" v-if="goto_app && action_pages_redirect_url" role="navigation" @click="gotoApp()" v-cb-link = "'color'">
          <div class="cb-section__link cb-section__link--ac">{{ goToAppText }} &rarr;</div>
        </div>
      </div>
      <div class="cb-header__content" v-else key="referral" :class="{'cb-header__content--fade': fadeHeaderContent}">
        <referral-section>
          <div class="cb-header__close" v-if="thankYouClose">
            <button-field @next="close()" :custom-class="'secondary sm'" aria-label="close checkout" :attr="'cb_close'">
              {{ thankYouClose }}
            </button-field>
          </div>
        </referral-section>
      </div>
    </cb-slide-n-fade>
  </div>
</div>